import React, {useEffect, useState} from "react";
import {BigInput} from "../bigInput/BigInput";
import BigPicker from "../bigPicker/BigPicker";
import {daysOptions} from "../../modals/blackoutPeriodModals/daysOptions";
import {countryCodesList} from "../../../utils/countryCodesList";
import axios from "axios";
import "./phone-number.css";
import CountriesSelector from "../../contriesSelector/CountriesSelector";

interface PhoneProps {
    onPhoneChange: (newPhone: string) => void;
    onPhoneWithPrefixChange?: (newPhoneWithPrefix: string) => void;
    onCountryChange: (newCountryCode: string) => void;
    phone: string;
    country: string;
    withCountryCode?: boolean;
    required?: boolean;
    placeholder?: string;
}

const PhoneNumber = ({ phone, country, onPhoneChange, onCountryChange, onPhoneWithPrefixChange, withCountryCode = true, required = false, placeholder }: PhoneProps) => {
    const [countryCodes, setCountryCodes] = useState<{ label: string, value: string, img?: string }[]>([]);

    const setCountryItemByCurrentLocation = async () => {
        const ip = await getIp();
        const res = await axios.get(`https://api.country.is/${ip}`);
        const countryItem = countryCodesList.find(country => country.country === res.data.country);
        if(countryItem?.country) {
            onCountryChange(countryItem?.country);
        }
    }

    const setCountryOptions = async () => {
        setCountryCodes(countryCodesList.map(country => {
            return {
                label: `${country.country} +${country.code}`,
                value: withCountryCode ? country.country : `${country.country} +${country.code}`,
                img: `http://purecatamphetamine.github.io/country-flag-icons/3x2/${country.country.toUpperCase()}.svg`
            };
        }));
    }

    const getIp = async () => {
        const res = await axios.get("https://api.ipify.org/?format=json");
        return res.data.ip;
    }

    const initiate = async () => {
        await setCountryOptions();
        if(!country) {
            await setCountryItemByCurrentLocation();
        }
    }

    useEffect(() => {
        initiate();
    }, []);

    useEffect(() => {
        if(onPhoneWithPrefixChange) {
            const countryItem = countryCodesList.find(countryItem => countryItem.country === country);
            if(countryItem) {
                if(phone?.indexOf('0') === 0) {
                    onPhoneWithPrefixChange(`${countryItem.code}${phone.substring(1)}`);
                } else {
                    onPhoneWithPrefixChange(`${countryItem.code}${phone}`);
                }
            }
        }
    }, [onPhoneWithPrefixChange, phone, country]);

    return (
        <div className="phone-number-field-container">
            <CountriesSelector selectedCountry={country || 'US'} setSelectedCountry={(newVal) => onCountryChange(newVal.toString())} valueProp="country" hideCountryName={true} />
            {/*<BigPicker selectClassName="phone-number-prefix-field" value={country} setValue={(newVal) => onCountryChange(newVal.toString())} options={countryCodes}/>*/}
            <div className="hyphen">-</div>
            <BigInput
                value={phone || ''}
                setValue={onPhoneChange}
                placeholder={placeholder || "Phone Number"}
                className="phone-number-phone-field"
                required={required}
            />
        </div>
    )
}

export default PhoneNumber;